export function SET_PARAMS({commit}, [login, clients, register, user_profile, languages, attempts, layout]) {
    commit( 'SAVE_PARAMS', [ login, clients, register, user_profile, languages, attempts, layout ] )
}

export function SET_ATTEMPTS({ commit }, [attempts]) {
    commit('SAVE_ATTEMPTS', [attempts])
}